// extracted by mini-css-extract-plugin
export default {"root":"FreeShippingBadge-module__root___KxY2a","text":"FreeShippingBadge-module__text___SJfAf"};